import template from "./access-from-mobile.html";

const AccessFromMobileComponent = {
  template: template,
  controller: class LogInPageController {
    /* @ngInject */
    constructor($window) {
      this.$window = $window;
    }

    goToHelp() {
      this.$window.location.href = `http://help.quoters.io`;
    }
  },
};

export default AccessFromMobileComponent;
